import { render, staticRenderFns } from "./LinkPay.vue?vue&type=template&id=36168a6d&scoped=true"
import script from "./LinkPay.vue?vue&type=script&lang=js"
export * from "./LinkPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36168a6d",
  null
  
)

export default component.exports